import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createInitOptions } from '@org/i18n';

let initPromise: Promise<typeof i18next> | null = null;

export const getI18n = () => i18next;

export const ensureAdminI18n = () => {
  if (!initPromise) {
    initPromise = i18next.use(initReactI18next).init(createInitOptions());
  }
  return initPromise;
};












